export interface PostulacionModel {
  id_postulacion: number;
  convocatoria_id: number;
  numero_documento_participante: number;
  nombre_propuesta: string;
  nombre_participante: string;
  jurados: Array<Object>;
  estado_jurado: boolean;
  fecha_creacion: string;
  tipo_participante: string;
  links: Array<Object>;
  nombre_convocatoria: string;
  categoria_linea_convocatoria: Array<Object>;
  fecha_apertura: string;
  fecha_actualizacion: string;
  particiapnte: Array<Object>;
  estado: string;
  documentos_generales: Array<Object>;
  documentos_tecnicos: Array<any>;
  documentos_administrativos: any;
  linea_convocatoria: number;
  radicado: string;
  observaciones: string;
  area: string,
  participantes: Array<Object>
}

export const initialValuesPostulacionModel = {
  id_postulacion: 0,
  convocatoria_id: 0,
  numero_documento_participante: 0,
  nombre_propuesta: "",
  nombre_participante: "",
  jurados: [],
  estado_jurado: false,
  fecha_creacion: "",
  tipo_participante: "",
  links: [],
  nombre_convocatoria: "",
  categoria_linea_convocatoria: [],
  fecha_apertura: "",
  fecha_actualizacion: "",
  particiapnte: [],
  estado: "",
  documentos_generales: [],
  documentos_tecnicos: [],
  documentos_administrativos: [],
  linea_convocatoria: 0,
  radicado: "",
  observaciones: "",
  area: "",
  participantes: []
};

export interface filtrosPostulacionModel {
  buscarpalabra: string;
  linea_estrategica: any;
  categoria: any;
  estado: any;
  anio: Array<string | number>;
}

export const initialFiltrosPostulacionModel = {
  buscarpalabra: "",
  linea_estrategica: null,
  categoria: null,
  estado: null,
  anio: null
};

